import React, { memo } from 'react';
import { AuthorisationConsumer, RequestProvider } from '@shootsta/common-react';
import { archiveOutputApi, unarchiveOutputApi } from '../../../api';
import ArchiveModalComponent from '../components/ArchiveModal';

type ArchiveModalProps = {
  isShowArchived: boolean;
  video?: Video;
  visible: boolean;
  onConfirmation: any;
  onClose: any;
};

function ArchiveModal(props: ArchiveModalProps) {
  return (
    <AuthorisationConsumer requiresOrganisation>
      {({ selectedOrganisation: { name } }) => (
        <RequestProvider
          requests={{
            archiveOutput: archiveOutputApi,
            unarchiveOutput: unarchiveOutputApi
          }}
        >
          {(requests) => (
            <ArchiveModalComponent
              organisationName={name}
              {...requests}
              {...props}
            />
          )}
        </RequestProvider>
      )}
    </AuthorisationConsumer>
  );
}

export default memo<ArchiveModalProps>(ArchiveModal);
